import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/finalize`;

export const ROUTE: RouteDefinition = `${baseRoute}/finalize`;

export const URL = (): RouteDefinition => `${baseRoute}/finalize`;
